import { useEffect, useState } from "react";
import axiosInstance from "../../../axiosConfig";
import { showToast } from "../../Toast";
import { handleError } from "../../../services/handleError";
import Loading from "../../../pages/Loading";

export default function TemposPedidoConfig() {
    const [loading, setLoading] = useState(false);

    const [tempos, setTempos] = useState({
        tempoMinimoPreparo: "",
        tempoMaximoPreparo: "",
        tempoMinimoEntrega: "",
        tempoMaximoEntrega: "",
    });

    useEffect(() => {
        (async () => {
            setLoading(true);
            try {
                const res = await axiosInstance.get("Configs/Tempos");
                setTempos(res.data);
            } catch (err) {
                handleError(err, "Erro ao carregar tempos.");
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    const salvar = async () => {
        try {
            await axiosInstance.put("Configs/Tempos", tempos);
            showToast("Sucesso!", "success", 3000, "Tempos atualizados com sucesso!");
        } catch (err) {
            handleError(err, "Erro ao salvar tempos.");
        }
    };

    if (loading) {
        return <Loading />;
    }

    return (
        <div className="w-full p-6">
            <div className="space-y-2">
                <h2 className="text-xl md:text-2xl font-semibold text-gray-900">Definir Prazos</h2>
                <p className="text-gray-700">Configure o tempo de preparo dos pedidos e o prazo estimado de entrega.</p>
            </div>

            <div className="mt-4 space-y-2">
                <label className="block text-gray-700">Tempo de Preparo (minutos)</label>
                <div className="flex space-x-2">
                    <input type="number" placeholder="Preparo mínimo" value={tempos.tempoMinimoPreparo} onChange={(e) => setTempos({ ...tempos, tempoMinimoPreparo: e.target.value })} className="w-1/2 p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" />
                    <input type="number" placeholder="Preparo máximo" value={tempos.tempoMaximoPreparo} onChange={(e) => setTempos({ ...tempos, tempoMaximoPreparo: e.target.value })} className="w-1/2 p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" />
                </div>

                <label className="block text-gray-700 pt-4">Tempo Estimado de Entrega (minutos)</label>
                <div className="flex space-x-2">
                    <input type="number" placeholder="Entrega mínima" value={tempos.tempoMinimoEntrega} onChange={(e) => setTempos({ ...tempos, tempoMinimoEntrega: e.target.value })} className="w-1/2 p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" />
                    <input type="number" placeholder="Entrega máxima" value={tempos.tempoMaximoEntrega} onChange={(e) => setTempos({ ...tempos, tempoMaximoEntrega: e.target.value })} className="w-1/2 p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" />
                </div>
            </div>

            <div className="mt-4 flex justify-end">
                <button onClick={salvar} className="bg-blue-600 text-white px-4 py-2 rounded">
                    Salvar
                </button>
            </div>
        </div >
    );
}